import { Observable, of } from 'rxjs'
import { catchError, merge } from 'rxjs/operators'

import { Movement, Featured } from '@skinsoft/types'
import { movementSelectors } from '@skinsoft/selectors'
import { MovementDataStore } from '@skinsoft/entity'
import { resolveAuthor } from '@skinsoft/entity-ui/src/resolve-author'

export function toFeatured$(movement: Movement): Observable<Featured> {
    const featured: Featured = {
        // @ts-ignore
        author: movementSelectors.author(movement),
        date: movementSelectors.endDate(movement),
        // @ts-ignore
        description: movementSelectors.title(movement),
        headerDate: movementSelectors.startDate(movement),
        // @ts-ignore
        highlight: MovementDataStore.highlightStates.includes(movementSelectors.state(movement)),
        id: movement.id,
        // @ts-ignore
        state: movementSelectors.state(movement),
        stateLabel: `movement.state.${movementSelectors.state(movement)}`,
        // @ts-ignore
        title: movementSelectors.incrementalTitle(movement),
    };

    const featured$ = of(featured);

    return featured$.pipe(
        merge(of({ ...featured, author: null } as Featured), featured$.pipe(
            resolveAuthor,
        ) as Observable<Featured>),
        catchError(error => of({ ...featured, author: error })),
    );
}
